// src/components/PrivacyPolicy.js
import React from "react";
import "./PrivacyPolicy.css"; // Import CSS file for styling

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="header-banner">
        <h1>Privacy Policy</h1>
        <p>Your privacy matters to us. Here's how we handle your data securely.</p>
      </div>

      <div className="content">
        <section>
          <h2>1. Information We Collect</h2>
          <p>
            We may collect personal details like your name, email address, phone
            number when you interact with our platform.
          </p>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <p>
            Your information is used to provide, improve, and personalize our
            services, process transactions, and communicate important updates.
          </p>
        </section>

        <section>
          <h2>3. Sharing Your Information</h2>
          <p>
            We do not sell your information to third parties. However, we may share
            your details with trusted partners or as required by law.
          </p>
        </section>

        <section>
          <h2>4. Data Security</h2>
          <p>
            We implement robust measures to protect your information. However, no
            method of transmission over the internet is entirely secure.
          </p>
        </section>

        <section>
          <h2>5. Your Choices</h2>
          <p>
            You can manage your preferences or opt out of certain features by
            contacting our support team.
          </p>
        </section>

        <section>
          <h2>6. Contact Us</h2>
          <p>
            If you have any questions or concerns about this Privacy Policy, please
            contact us at <a href="mailto:support@kliq.com">support@kliq.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
